import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import DOMPurify from "dompurify";
import axios from "axios";

export default function RoiRate() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // let user = "";
  const [IP, setIP] = useState("");
  const [referralApi, setreferralApi] = useState([]);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState(0);
  const [sidsearch, setSidSearch] = useState("");
  const [TotalAmount, setTotalAmount] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [currentPage2, setcurrentPage2] = useState(1);
  const [listPerpage2, setlistPerpage2] = useState(10);

  useEffect(() => {
    const GetIp = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setIP(response.data.ip);
      } catch {
        toast.error("Error in getting IP");
      }
    };
    GetIp();
  }, []);

  const handleChange = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value).replace(
      /[^0-9.]/g,
      ""
    );
    const limitedValue = sanitizedValue.slice(0, 8);

    setSearch(limitedValue);
  };

  const referral_API = async (type) => {
    try {
      let responceRight = await API?.post(
        "/GetUpdateRoiRateList",
        {
          loginid: userId,
          rate: search,
          type: type,
          ip_address: IP,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("roirate-->", responceRight);
      responceRight = responceRight.data.data[0];
      if (type === "2") {
        setleftreferralApi([]);
        let arrayLeft = [];

        responceRight.forEach((item, index) => {
          arrayLeft.push({
            sr: index + 1,
            roi: `${item?.roi_rate} `,
            dd: item?.dd,
            ip_address: item?.ip_address,
          });

          setleftreferralApi(arrayLeft);
        });
      } else if (type === "1") {
        toast.success("ROI rate updated successfully!");
        setSearch("");
        referral_API("2");
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API("2");
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const indexOfLastPost2 = currentPage2 * listPerpage2;
  const indexOfFirstPage2 = indexOfLastPost2 - listPerpage2;
  const currentPost = referralApi.slice(indexOfFirstPage, indexOfLastPost);
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage2,
    indexOfLastPost2
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "ROI Rate", accessor: "roi" },
      { Header: "Ip Address", accessor: "ip_address" },
      { Header: "Date", accessor: "dd" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page content_page_hit">
        <div class="content">
          <div class="container">
            {/* <-- inline Form --> */}
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <h4 class="panel-title">Roi Rate Report</h4>
                  </div>
                  <div class="panel-body">
                    <form
                      action="#"
                      method="post"
                      class="ng-pristine in-ip-1 ng-valid">
                      <div class="form-inline" role="form">
                        <div class="col-md-12">
                          <div class="col-lg-2 col-xl-2 col-md-3">
                            <label>Current ROI Rate :</label>
                            <br />
                            <input
                              class="form-control in-ip-1"
                              id="uid"
                              onChange={handleChange}
                              name="uid"
                              placeholder="Enter Rate"
                              type="text"
                              value={search}
                            />
                          </div>

                          <div class="col-lg-2 col-xl-2 col-md-3">
                            <br />
                            <input
                              type="reset"
                              id="btnsearch"
                              formmethod="get"
                              onClick={() => referral_API("1")}
                              class="btn btn-lg btn-primary"
                              value="Update"
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-default">
                  <div class="panel-body" style={{ overflow: "scroll" }}>
                    <Table data={currentPostleft} columns={my_team.cols} />

                    {/* <Table_Buttons
                      indexOfFirstPage={indexOfFirstPage2}
                      indexOfLastPost={indexOfLastPost2}
                      setcurrentPage={setcurrentPage2}
                      currentPage={currentPage2}
                      totalData={leftreferralApi.length}
                      listPerpage={listPerpage2}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
